/* Copyright (c) 2018 Backpack Health LLC */
import React from 'react';
import { FormattedMessage } from 'react-intl';

import ContentWrapper from '../../components/ContentWrapper';
import { SurveyPageLayout } from './SurveyQuestion/components/SurveyPageLayout';
import { AnsweredSections } from './components/AnsweredSections';

import RouteNames from '../../appAuthorized/RouteNames';
import { useUIState } from '../../hooks/useUIState';
import { useNavigate } from '../../hooks/useNavigate';
import { useSurveyForActiveProfile, useSurveyDefinitionQuestionsForActiveProfile } from '../../hooks/useSurvey';
import ContentLoader from '../../components/ContentLoader';

export const SurveyReview = (props) => {
  const groupId = Number(props.match.params.groupId);
  const surveyId = Number(props.match.params.surveyId);

  const [, uiStateActions] = useUIState();
  const [isSubmitted, setIsSubmitted] = React.useState(false);

  const [, navigateActions] = useNavigate();
  const [surveyData, surveyActions] = useSurveyForActiveProfile(surveyId);
  const { survey } = surveyData;
  const surveyDefId = survey.survey_definition_id;
  const [surveyQuestionDefData] = useSurveyDefinitionQuestionsForActiveProfile(surveyDefId);
  const isLoaded = surveyQuestionDefData.isLoaded && surveyData.isLoaded;
  const redirectToInformedConsent = () => {
    // no-op
  };

  const prev = () => {
    navigateActions.goTo(RouteNames.surveyLastQuestion(groupId, surveyId));
  };

  const submit = () => {
    if (isSubmitted) { return; }

    setIsSubmitted(true);
    surveyActions.markSubmitted()
      .then(() => {
        navigateActions.goTo(RouteNames.surveySubmitted(groupId, surveyId));
      })
      .catch((apiError) => {
        if (apiError.isUnavailableForLegalReasons()) {
          setIsSubmitted(false);
          redirectToInformedConsent();
          return;
        }
      });
  };

  React.useEffect(() => {
    uiStateActions.setActiveGroup(groupId);
  }, []);

  return (
    <SurveyPageLayout
      className="bkgd-color-csAppBGgray"
      navButtons={{
        prev,
        submit,
        color: 'theme-group base fill',
        submitProps: {
          theme: 'group',
        },
      }}
      submitDisabled={isSubmitted}
      title={<FormattedMessage id="surveyReview.title.text"/>}
      groupId={groupId}
      progressPercentage={survey.completion_percentage}
    >
      <ContentLoader isContentLoaded={isLoaded && !isSubmitted} blockRenderUntilLoaded={!isSubmitted} isFixed={true}>
        <ContentWrapper>
          <div className="cmp-scrollaware__content">
            <AnsweredSections survey={survey} />
          </div>
        </ContentWrapper>
      </ContentLoader>
    </SurveyPageLayout>
  );
};
